import React, { useState, useEffect, ForwardedRef, forwardRef, InputHTMLAttributes } from "react";
import useForwardRef from "../../../../hooks/useForwardRef";
import styles from "./addressFormPhone.module.scss";

interface IProps {
	value: string;
	onChange: (value: string) => void;
	label: string;
	error?: string;
	inputProps?: InputHTMLAttributes<HTMLInputElement>;
}

const AddressFormPhone = forwardRef((props: IProps, ref: ForwardedRef<HTMLInputElement>) => {
	const { onChange, label, value: initialValue, inputProps, error } = props;
	const [inputValue, setInputValue] = useState("");
	const forwardedRef = useForwardRef(ref);

	useEffect(() => {
		if (initialValue) {
			const strippedValue = initialValue.replace(/^\+234\s*/, "");
			setInputValue(formatPhoneNumber(strippedValue));
		} else { setInputValue('')}
	}, [initialValue]);

	const handleContainerClick = () => {
		if (forwardedRef?.current) {
			forwardedRef.current.focus();
		}
	};

	const formatPhoneNumber = (value: string) => {
		const numbers = value.replace(/\D/g, "");
		const char = { 3: " ", 7: " " };
		let formatted = "";
		for (let i = 0; i < numbers.length; i++) {
			formatted += (char[i as keyof typeof char] || "" || "") + numbers[i];
		}
		return formatted.trim();
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const rawValue = e.target.value.replace(/\D/g, "");
		const formattedValue = formatPhoneNumber(rawValue);
		setInputValue(formattedValue);

		// Pass the full formatted value (including +234) to the parent component
		if (onChange) {
			onChange(`+234 ${formattedValue}`);
		}
	};

	return (
		<button type="button" onClick={handleContainerClick} className={styles.container}>
			<label className={styles.inputLabel}>{label}</label>
			<input
				type="tel"
				{...inputProps}
				className={styles.inputValue}
				value={inputValue}
				onChange={handleChange}
				placeholder="Enter phone number"
				ref={forwardedRef}
			/>
			{error && <div className={styles.error}>{error}</div>}
		</button>
	);
});

export default AddressFormPhone;
